import {Templates} from '../helpers/templates';
import {ElementHelpers} from '../helpers/element-helpers';

export class Modal {
	constructor(modalContent) {
		this.initModal(modalContent);

		this.actionCallback = null;
	}

	initModal(modalContent){
		const modal = document.createElement('div');
		modal.classList.add('modal');
		document.body.appendChild(modal);
		Templates.renderTemplate(this.modalTemplate(), modal, modalContent);

		this.close = modal.querySelectorAll('[data-modal-close]');
		this.action = modal.querySelector('[data-modal-action]');
		this.addModalEventHandlers(modal);
	}

	addModalEventHandlers(modal) {
		ElementHelpers.addEventListeners(this.close, 'click', () => {
			this.closeModal(modal);
		});

		if(this.action) {
			this.action.addEventListener('click', () => {
				this.closeModal(modal);
				// execute callback function, if set
				if (this.actionCallback && typeof this.actionCallback === 'function')
					this.actionCallback();
			})
		}
	}

	closeModal(modal){
		ElementHelpers.removeElement(modal);
	}

	/**
	 * Call this method with a callback which fires when the 'action-button' is clicked
	 * @param callback {Function}
	 */
	handleAction(callback) {
		this.actionCallback = callback;
	}

	modalTemplate() {
		return `
			<div class="modal__background" data-modal-close></div>
			<div class="modal__container">
				<div class="modal__inner">
					<div class="modal__content" data-modal-content>
						{{#title}}
						<h2>{{title}}</h2>
						{{/title}}
						{{#text}}
						<p class="leadtext">{{text}}</p>
						{{/text}}
					</div>
					
					{{#actionButton}}
					<div class="modal__bottom flex--horizontal flex--wrap">
						<button class="reset-button link__button link__button--primary" data-modal-action>{{actionButton}}</button>
						{{#closeButton}}<button class="reset-button link" data-modal-close>{{closeButton}}</button>{{/closeButton}}
					</div>
					{{/actionButton}}
				</div>
			</div>
		`
	}
}
